// custom typefaces
import "typeface-lora"
//TODO npm uninstall the below
//import "typeface-montserrat"
//import "typeface-merriweather"

export function shouldUpdateScroll(){
    return false;
  };